import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { trackBookingClick, trackWhatsAppClick, trackPhoneClick, trackNavigation } from '../utils/analytics';
import { cloudImg } from '../config/images';

const Navbar = () => {
  const [isScrolling, setIsScrolling] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    let scrollTimeout;
    
    const handleScroll = () => {
      setIsScrolling(true);
      
      // Clear existing timeout
      clearTimeout(scrollTimeout);
      
      // Set timeout to stop animation after scrolling stops
      scrollTimeout = setTimeout(() => {
        setIsScrolling(false);
      }, 150);
    };

    window.addEventListener('scroll', handleScroll);
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
      clearTimeout(scrollTimeout);
    };
  }, []);

  const handleNavigation = (path) => {
    trackNavigation(path);
    navigate(path);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <nav className="navbar">
      <div className="nav-container" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0' }}>
        {/* Left Side - Grand Beach Villa Logo */}
        <div 
          className="nav-logo-left" 
          onClick={() => handleNavigation('/')}
          style={{ 
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
            flex: '0 0 auto',
            paddingLeft: '0',
            marginLeft: '0'
          }}
        >
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'flex-start'
          }}>
            <span style={{
              fontSize: '22px',
              fontWeight: '700',
              color: '#FF6B45',
              letterSpacing: '0.5px',
              lineHeight: '1.2',
              whiteSpace: 'nowrap'
            }}>
              Near the Beach
            </span>
            <span style={{
              fontSize: '12px',
              color: '#888',
              fontWeight: '500',
              letterSpacing: '1px'
            }}>
              BEACHFRONT STAYS IN KANNUR
            </span>
          </div>
          <img
            src={cloudImg('logo-grandbeachvilla.png')}
            alt="Near the Beach Logo"
            style={{
              height: '90px',
              width: 'auto',
              objectFit: 'contain'
            }}
          />
        </div>
        
        {/* Center - Navigation Menu */}
        <ul className="nav-menu" style={{ display: 'flex', gap: '20px', margin: '0', padding: '0', listStyle: 'none' }}>
          <li className="nav-item">
            <button
              className={`nav-link ${location.pathname === '/explore-kannur' ? 'active' : ''} ${isScrolling ? 'scroll-animate' : ''}`}
              onClick={() => handleNavigation('/explore-kannur')}
              style={{ fontSize: '16px' }}
            >
              Explore Kannur
            </button>
          </li>
          <li className="nav-item">
            <button
              className={`nav-link nav-link-primary ${location.pathname === '/Grandbeachvilla' ? 'active' : ''} ${isScrolling ? 'scroll-animate' : ''}`}
              onClick={() => handleNavigation('/Grandbeachvilla')}
              style={{ fontSize: '16px' }}
            >
              Where to Stay
            </button>
          </li>
        </ul>
        
        {/* Right Side - Action Buttons */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '20px', flex: '0 0 auto', marginLeft: '20px', paddingRight: '0', marginRight: '0' }}>
          {/* Book Now Button */}
          <div className="nav-book-now" style={{ position: 'relative' }}>
            <button 
              className="book-now-button urgent-cta"
              aria-label="Book your stay at Grand Beach Villa now"
              title="Hurry Up! Book Now - Grand Beach Villa"
              onClick={() => {
                trackBookingClick('navbar');
                window.open('https://app.merusync.com/booknow/grand-beach-villa-24726', '_blank', 'noopener,noreferrer');
              }}
              style={{
                transition: 'all 0.3s ease',
                transform: 'scale(1)',
                background: 'linear-gradient(45deg, #FF6B45, #E0532E)',
                color: 'white',
                fontWeight: 'bold',
                fontSize: '16px',
                padding: '8px 16px',
                border: 'none',
                borderRadius: '20px',
                cursor: 'pointer',
                boxShadow: '0 4px 15px rgba(255, 107, 69, 0.4)',
                animation: 'pulse 2s infinite',
                zIndex: 1000,
                height: '36px',
                whiteSpace: 'nowrap'
              }}
              onMouseEnter={(e) => {
                setShowTooltip(true);
                e.target.style.transform = 'scale(1.1)';
                e.target.style.background = 'linear-gradient(45deg, #E0532E, #C2401F)';
                e.target.style.boxShadow = '0 6px 25px rgba(224, 83, 46, 0.6)';
                e.target.style.animation = 'none';
              }}
              onMouseLeave={(e) => {
                setShowTooltip(false);
                e.target.style.transform = 'scale(1)';
                e.target.style.background = 'linear-gradient(45deg, #FF6B45, #E0532E)';
                e.target.style.boxShadow = '0 4px 15px rgba(255, 107, 69, 0.4)';
                e.target.style.animation = 'pulse 2s infinite';
              }}
            >
              🔥 Book Now & Save
            </button>
            {showTooltip && (
              <div style={{
                position: 'absolute',
                top: '100%',
                left: '50%',
                transform: 'translateX(-50%)',
                marginTop: '8px',
                padding: '12px 16px',
                background: 'linear-gradient(135deg, #2ecc71, #27ae60)',
                color: 'white',
                borderRadius: '8px',
                fontSize: '13px',
                fontWeight: '600',
                whiteSpace: 'nowrap',
                zIndex: 1001,
                boxShadow: '0 4px 16px rgba(46, 204, 113, 0.4)',
                pointerEvents: 'none',
                animation: 'fadeIn 0.3s ease-in',
                border: '2px solid rgba(255, 255, 255, 0.3)'
              }}>
                ✅ No Payment Required Now!<br />
                <span style={{ fontSize: '11px', opacity: '0.95' }}>
                  Secure your spot before it's gone - Pay later !
                </span>
                <div style={{
                  position: 'absolute',
                  top: '-6px',
                  left: '50%',
                  transform: 'translateX(-50%)',
                  width: 0,
                  height: 0,
                  borderLeft: '6px solid transparent',
                  borderRight: '6px solid transparent',
                  borderBottom: '6px solid #2ecc71'
                }} />
              </div>
            )}
            <style jsx>{`
              @keyframes pulse {
                0% { box-shadow: 0 4px 15px rgba(255, 107, 69, 0.4); }
                50% { box-shadow: 0 4px 25px rgba(255, 107, 69, 0.8); }
                100% { box-shadow: 0 4px 15px rgba(255, 107, 69, 0.4); }
              }
              @keyframes fadeIn {
                from { opacity: 0; transform: translateX(-50%) translateY(-5px); }
                to { opacity: 1; transform: translateX(-50%) translateY(0); }
              }
            `}</style>
          </div>
          
          {/* WhatsApp & Call Buttons */}
          <div className="nav-contact-buttons" style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
            <a 
              href="https://api.whatsapp.com/send/?phone=919895162332&text=Hello+Grand+Beach+Villa%2C+I+want+to+book+my+room."
              target="_blank"
              rel="noopener noreferrer"
              className="whatsapp-nav-button"
              aria-label="Contact us on WhatsApp"
              title="Contact Grand Beach Villa on WhatsApp"
              onClick={() => trackWhatsAppClick('navbar')}
              style={{
                display: 'flex',
                alignItems: 'center',
                background: '#25D366',
                color: 'white',
                borderRadius: '50%',
                width: '48px',
                height: '48px',
                justifyContent: 'center',
                textDecoration: 'none',
                boxShadow: '0 2px 8px rgba(37, 211, 102, 0.3)',
                transition: 'all 0.2s'
              }}
              onMouseEnter={e => {
                e.currentTarget.style.background = '#128C7E';
                e.currentTarget.style.transform = 'scale(1.1)';
              }}
              onMouseLeave={e => {
                e.currentTarget.style.background = '#25D366';
                e.currentTarget.style.transform = 'scale(1)';
              }}
            >
              <svg viewBox="0 0 24 24" width="26" height="26" fill="currentColor">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.890-5.335 11.893-11.893A11.821 11.821 0 0020.893 3.488"/>
            </svg>
            </a>
            <a
              href="tel:+919895162332"
              className="call-nav-button"
              aria-label="Call Grand Beach Villa"
              title="Call Grand Beach Villa"
              onClick={() => trackPhoneClick('navbar')}
              style={{
                display: 'flex',
                alignItems: 'center',
                background: '#1976d2',
                color: 'white',
                borderRadius: '50%',
                width: '48px',
                height: '48px',
                justifyContent: 'center',
                textDecoration: 'none',
                boxShadow: '0 2px 8px rgba(25, 118, 210, 0.3)',
                transition: 'all 0.2s'
              }}
              onMouseEnter={e => {
                e.currentTarget.style.background = '#1565c0';
                e.currentTarget.style.transform = 'scale(1.1)';
              }}
              onMouseLeave={e => {
                e.currentTarget.style.background = '#1976d2';
                e.currentTarget.style.transform = 'scale(1)';
              }}
            >
              <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
                <path d="M6.62 10.79a15.053 15.053 0 006.59 6.59l2.2-2.2a1 1 0 011.01-.24c1.12.37 2.33.57 3.58.57a1 1 0 011 1v3.61a1 1 0 01-1 1C10.07 22 2 13.93 2 4a1 1 0 011-1h3.61a1 1 0 011 1c0 1.25.2 2.46.57 3.58a1 1 0 01-.24 1.01l-2.2 2.2z"/>
            </svg>
            </a>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
